module.exports = __webpack_public_path__ + "static/04-4e803eff8748690a7672313f4970c794.jpg";